import * as Sentry from "@sentry/react";
import {BrowserTracing} from "@sentry/react";
import {getFrontendReleaseCode, getSentryDsn} from "src/config/appConfig.ts";
import {CaptureConsole} from "@sentry/integrations";

export const setupSentry = () => {
    Sentry.init({
        dsn: getSentryDsn(),
        release: getFrontendReleaseCode(),
        integrations: [
            new CaptureConsole({
                levels: ["error", "warn"]
            }),
            new BrowserTracing()
        ],
        tracesSampleRate: 1.0
    });
};
